import AFRAME from "aframe";

AFRAME.registerComponent('set-sky', {
    dependencies: [],
    schema: {type: 'string', default: ''},
    init() {
        const me = this;

        me.el.addEventListener('click', () => {
            const sky = document.querySelector('#sky');
            const nav = document.querySelector('#navigationPanel');
            const skyUrl = me.data;

            nav.setAttribute('visible', false);
            sky.setAttribute('material',{
                src: me.data
            });

            // let assets = document.querySelector('a-assets');
            // let x = document.createElement('img');
            //
            // x.setAttribute('id','myid');
            // x.addEventListener('load', (event) => {
            //     console.log('load', event);
            //
            //     sky.setAttribute('material', {
            //         src: '#myid'
            //     });
            // });
            // x.setAttribute('src', skyUrl);
            // assets.append(x);

        });
    },
    update() {

    }
});